import { fb } from "@/plugins/firebase.js";

async function getOrgStats(data) {
  const type = data.queryType;
  const orgid = data.orgId;
  const userid = data.userId;

  let dateStart = data.datesrange[0];
  let dateEnd = data.datesrange[1];

  let dateRangeType = data.datesrangetype;

  let queryToApply = "";
  switch (type) {
    // USERS
    case "totUsers":
      queryToApply = `SELECT COUNT(DISTINCT user_id) as tot 
              FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
              WHERE Date(user_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
              `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      break;
    case "totActiveUsers":
      queryToApply = `SELECT COUNT(DISTINCT user_id) as tot
              FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
              WHERE Date(transc_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
              `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      break;
    // TRANSCRIPTIONS
    case "totTranscriptions":
      queryToApply = `SELECT COUNT(DISTINCT transc_id) as tot
              FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
              WHERE Date(transc_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
              `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      if (userid != "") {
        queryToApply += `AND user_id = '${userid}'`;
      }
      break;
    case "totTranscTime":
      queryToApply = `SELECT SUM(cast(transc_audioDuration as FLOAT64)) as tot
              FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
              WHERE Date(transc_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
              `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      if (userid != "") {
        queryToApply += `AND user_id = '${userid}'`;
      }
      break;
    // LISTS
    case "listTranscriptions":
      queryToApply = `SELECT *
              FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
              WHERE transc_timestamp >= '${dateStart}' AND transc_timestamp < '${dateEnd}'
              `;
      if (orgid && orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      if (userid && userid != "") {
        queryToApply += `AND user_id = '${userid}'`;
      }
      break;
    case "listUsersTranscriptions":
      queryToApply = `SELECT user_id,
            COUNT(DISTINCT transc_id) as count,
            MAX(user_email) AS user_email,
            MAX(user_name) AS user_name,
            SUM(cast(transc_audioDuration as FLOAT64)) as time
            FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
            WHERE Date(transc_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
            `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      queryToApply += `GROUP BY user_id
                             ORDER BY time DESC`;
      break;
    case "listNotActivatedUsers":
      queryToApply = `SELECT user_id,
            COUNT(DISTINCT transc_id) as count,
            MAX(user_email) AS user_email,
            MAX(user_name) AS user_name,
            SUM(cast(transc_audioDuration as FLOAT64)) as time
            FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
            WHERE Date(user_timestamp) between Date('${dateStart}') and Date('${dateEnd}')
            `;
      if (orgid != "") {
        queryToApply += `AND user_org_1 = '${orgid}'`;
      }
      queryToApply += `GROUP BY user_id
                             HAVING count < 1
                             ORDER BY count DESC`;
      break;
    // Charts
      case "chartUsageDataByTimeframe":
        queryToApply = `
                WITH date_range AS (
                  SELECT 
                    DATE_TRUNC(month, ${dateRangeType.bigquery_name}) AS month,
                  FROM UNNEST(
                      GENERATE_DATE_ARRAY(DATE('${dateStart}'), Date('${dateEnd}'), INTERVAL 1 ${dateRangeType.title})
                  ) as month
                ),
                
                monthly_counts_transcripts AS (
                  SELECT 
                    DATE_TRUNC(Date(transc_timestamp), ${dateRangeType.bigquery_name}) AS month,
                    COUNT(DISTINCT transc_id) AS transc_count,
                    SUM(cast(transc_audioDuration as FLOAT64)) AS transc_time
                  FROM \`${process.env.VUE_APP_PROJECT_ID}.transcripts.created_transcripts_users\`
                  WHERE transc_timestamp >= '${dateStart}' AND transc_timestamp < '${dateEnd}'
                  `;
                  if (orgid != "") {
                    queryToApply += `AND user_org_1 = '${orgid}'`;
                  }
                  if (userid != "") {
                    queryToApply += `AND user_id = '${userid}'`;
                  }
                queryToApply += ` GROUP BY month
                ),
                
                monthly_counts_users AS (
                  SELECT 
                    DATE_TRUNC(Date(  PARSE_DATETIME('%a, %d %b %E4Y %H:%M:%S GMT',  JSON_VALUE(data,'$.createdAt') )  ), ${dateRangeType.bigquery_name}) AS month,
                    COUNT(DISTINCT document_id) AS transc_count,
                  FROM \`${process.env.VUE_APP_PROJECT_ID}.users.posts_raw_latest\`
                  WHERE PARSE_DATETIME('%a, %d %b %E4Y %H:%M:%S GMT',  JSON_VALUE(data,'$.createdAt') ) >= '${dateStart}' AND PARSE_DATETIME('%a, %d %b %E4Y %H:%M:%S GMT',  JSON_VALUE(data,'$.createdAt') ) < '${dateEnd}'
                  `;
                  if (orgid != "") {
                    queryToApply += `AND JSON_VALUE(data,'$.organizations[0]') = '${orgid}'`;
                  }
                  if (userid != "") {
                    queryToApply += `AND document_id = '${userid}'`;
                  }
                queryToApply += ` GROUP BY month
                )
                
                SELECT 
                  date_range.month, 
                  COALESCE(monthly_counts_transcripts.transc_count, 0) as transc_count,
                  COALESCE(monthly_counts_transcripts.transc_time, 0) as transc_time,
                  COALESCE(monthly_counts_users.transc_count, 0) as signup_count
                FROM date_range
                LEFT JOIN monthly_counts_transcripts
                  ON date_range.month = monthly_counts_transcripts.month
                LEFT JOIN monthly_counts_users
                  ON date_range.month = monthly_counts_users.month
                ORDER BY date_range.month;
                `;
        // query saved as: "Admin panel - chartDataByYearMonth"
        // https://console.cloud.google.com/bigquery?sq=390436873929:cee9047405c346f18094271b34368345
        break;
      case "else2":
      queryToApply = "Saturday";
  }

  console.log(queryToApply);

  const getstats = fb
    .app()
    .functions("europe-west1")
    .httpsCallable("adminBigQueryOrgStats");
  try {
    const data = {
      query: queryToApply,
    };
    const orgstats = await getstats(data);
    return orgstats;
  } catch (error) {
    console.log(error);
  }
}

export { getOrgStats };
